import { Component } from '@angular/core';
import { CommonModule, JsonPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CookieService } from 'ngx-cookie-service';
import { ToastNotifService } from '../../../../../core/services/toastNotif.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { NgxMatTimepickerModule } from 'ngx-mat-timepicker';
import { ToastrService } from 'ngx-toastr';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import Swal from 'sweetalert2';
import {
  RegisterMemberNewPayload,
  CarList,
} from '../../../../../core/models/member.model';
import { LanguageService } from '../../../../../core/services/language.service';
import { Subscription } from 'rxjs';
import { MyProfile } from '../../../../../core/models/user.model';
import {
  InformationResponse,
  VehicleDetail,
  Color,
  Province,
  StatusAPIResponse,
  TaxpayerInfo,
  InsertLicensePayload,
  InsertLicenseResponse,
} from '../../../../../core/models/information.model';
import {
  FeeDetailsResponse,
  ObjectFeeResponse,
} from '../../../../../core/models/parking.model';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  MatNativeDateModule,
} from '@angular/material/core';
import {
  UserVehicleResponse,
  MyVehicleAllResponse,
  MyAddressAllResponse,
} from '../../../../../core/models/user.model';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {
  MatMomentDateModule,
  MomentDateAdapter,
} from '@angular/material-moment-adapter';
import { PssLoadingComponent } from '../../../../../tools/template/pss/pss-loading/pss-loading.component';
import { CityParkingDiscountByCodeResponse } from '../../../../../core/models/discount.model';
import { ApiHandlerService } from '../../../../../tools/services/api/handler-api/apiHandler.service';

import { ToastFailedComponent } from "../../../../../tools/template/toast/toast-failed/toast-failed.component";
import { ToastWarnComponent } from "../../../../../tools/template/toast/toast-warn/toast-warn.component";
import { ToastSuccessComponent } from "../../../../../tools/template/toast/toast-success/toast-success.component";
import { ToastCustomService } from '../../../../../tools/services/toast/toast-custom/toastCustom.service';
import { PssWarnComponent } from "../../../../../tools/template/pss/pss-warn/pss-warn.component";

import * as _moment from 'moment';
import { default as _rollupMoment } from 'moment';
import { ApiVehicleService } from '../../../../../core/services/api/Vehicle/api-vehicle';
import { ApiMemberCardService } from '../../../../../core/services/api/Member/api-member-card';
import { ApiMemberService } from '../../../../../core/services/api/Member/api-member';
import { ApiUserService } from '../../../../../core/services/api/User/api-user';
import { ApiDiscountService } from '../../../../../core/services/api/Discount/api-discount';
import { ApiLicenseService } from '../../../../../core/services/api/Vehicle/api-license';

const moment = _rollupMoment || _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-register-member',
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatMomentDateModule,
    NgxMatTimepickerModule,
    PssLoadingComponent,
    PssWarnComponent
  ],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
  templateUrl: './register-member.component.html',
  styleUrl: './register-member.component.css'
})
export class RegisterMemberComponent {
  /* ------------------- Value ------------------- */
  // ????
  userStatus: boolean = false;
  expire_date: string = '';
  popupMessage = '';
  originalDate: Date | null = null;
  expire_date_show: string = '';
  showInfoPopup = false;

  // Window
  windowState: string = 'ต่ออายุ';
  // Language
  currentLang: 'TH' | 'EN' = 'TH';
  sub: Subscription;
  // Headers
  providerName: string = 'TEST';
  // Vehicle Count
  vehicleCount: number = 1;

  // Date
  startDate: any = new Date();
  today = new Date();

  // Package
  CardOptions: {
    value: number;
    label: string;
    fee: number;
    fig_day: number;
    vehicle_type_name: string;
    subscription_id: number;
  }[] = [];
  customer_name: string = '';
  phoneNo: string = '';
  fig_day: number | null = null;
  fee: number | null = null;
  total: number = 0;

  // Vehicle Plate
  carPlateList: MyVehicleAllResponse[] = [];
  carFilteredPlateList: MyVehicleAllResponse[] = [];
  remarks: string = '';
  totalCalVehicle: number = 0;
  vehicleTypeState: string = '';


  // Discount code
  cityparkingDiscountByCode: CityParkingDiscountByCodeResponse | null = null;
  discountCode: string = '';
  typeDiscountCode: boolean = false;
  disableDiscountCode: boolean = false;
  discountPrice: number = 0;


  // Modal Vehicle Plate
  selectedBrand: string | null = null;
  selectedProvince: any = null;
  searchTerm: string = ''; // คำค้นหา
  ProvinceOptions: { value: string; label: string }[] = [];
  vehicleDetails: VehicleDetail[] = [];
  selectedModel: string | null = null;
  selectEngine: string | null = null;
  ModelOptions: { value: string; label: string }[] = [];
  BrandOptions: { value: string; label: string }[] = [];
  ColorOptions: { value: string; label: string }[] = [];
  license: string = '';

  // Vehicle Type
  CarOptions: { value: string; label: string }[] = [];
  selectVehicleType: string = '';
  selectedOption: number | null = null;
  subscription_id: number | null = null;
  fullFeeList: FeeDetailsResponse[] = []; // เก็บไว้กรองซ้ำได้

  // Tax
  selectedTaxType: string = '1';
  selectedAddress: MyAddressAllResponse | null = null;
  address_id: number = 0;
  addressListAll: MyAddressAllResponse[] = [];
  selectedColor: string | null = null;
  mainOffice: boolean = false;
  taxId: string = '';
  tax_phone: string = '';
  taxName: string = '';
  email: string = '';
  address: string = '';
  cardCode: string = '';
  branchName: string = '';
  branchNo: string = '';

  zipcode: string = '';

  tambons: any[] = [];
  amphures: any[] = [];
  provincess: any[] = [];
  province_name: string | null = null;
  amphure_name: string | null = null;
  tambon_name: string | null = null;

  selectedProvinceId: number | null = null;
  selectedAmphureId: number | null = null;
  selectedTambonId: number | null = null;

  filteredAmphures: any[] = [];
  filteredTambons: any[] = [];
  filteredAddressList: MyAddressAllResponse[] = [];

  // Custom Autocomplete Dropdown States
  provinceSearchText: string = '';
  showProvinceDropdown: boolean = false;

  amphureSearchText: string = '';
  showAmphureDropdown: boolean = false;

  tambonSearchText: string = '';
  showTambonDropdown: boolean = false;

  packageSearchText: string = '';
  showPackageDropdown: boolean = false;

  // API
  providerId: number = 0;
  token: string = '';
  uid: string = '';
  licenseAll: MyVehicleAllResponse[] = [];
  licenseFilteredCar: any[] = [];
  licenseFilteredMotorcycle: any[] = [];
  carList: CarList[] | null = null;
  vehicleId: number = 0;
  selectedLicense: string = '';

  // Security
  disabled: boolean = false;
  disabled_renew: boolean = false;
  licenseError: string | null = null;

  // Warn
  error: string = '';
  isLoading: boolean = false; // สถานะการโหลดข้อมูล
  isSaveLoading: boolean = false;
  isModalRenewWarn: boolean = false;

  /* ------------------- Style ------------------- */
  // Vehicle Plate
  selectCarPlate: MyVehicleAllResponse[] = [];

  // Package
  selectedCardOption: string = '';

  // Tax
  isRequestTax: boolean = false;
  showSelectAddress: boolean = false;

  // Modal Vehicle Plate
  isOpenSelectVehiclePlateModal: boolean = false;
  isOpenSelectVehicleProvince: boolean = false;

  // Modal
  showTaxModal: boolean = false;
  showModalVehiclePlate: boolean = false;
  showAddressModal: boolean = false;
  modalSelectVehicle: boolean = false;
  showModal_confirm: boolean = false;

  // Alert
  isSuccess: boolean = false;
  textSuccess: string = '';
  detailSuccess: string = '';
  isWarning: boolean = false
  textWarn: string = ''
  detailWarn: string = ''
  isError: boolean = false
  textError: string = ''
  detailError: string = ''

  constructor(
    private cookieService: CookieService,
    private apiVehicleService: ApiVehicleService,
    private apiMemberCardService: ApiMemberCardService,
    private apiMemberService: ApiMemberService,
    private apiUserService: ApiUserService,
    private apiLicenseService: ApiLicenseService,
    private apiDiscountService: ApiDiscountService,
    private apiHandler: ApiHandlerService,
    private toast: ToastNotifService,
    private toastCustomService: ToastCustomService,
    private router: Router,
    private http: HttpClient,

    private languageService: LanguageService
  ) {
    // Language
    this.sub = this.languageService.currentLang$.subscribe((lang) => {
      this.currentLang = lang;
    });

    // Toast
    this.toast = toast;

    const nav = this.router.getCurrentNavigation();
    const state = nav?.extras.state as {
      myData: any;
      vehicleId: number;
      expire_date: string;
      card_code: string;
      vehicleType: string;
      windowState: string;
    };
    // console.log('🚀 รับข้อมูลจากหน้าเดิม:', state);
    if (state) {
      this.userStatus = true;
      this.vehicleId = state.vehicleId;
      this.expire_date = state.expire_date;
      this.cardCode = state.card_code;
      this.selectVehicleType = state.vehicleType;
      if (this.cardCode) {
        console.log('มีบัตรสมาชิก', this.cardCode, state.card_code);
        this.disabled = true;
        this.disabled_renew = true;

        this.isModalRenewWarn = true;
      }

      const rawDate = this.expire_date ? new Date(this.expire_date) : null;
      const today = new Date();
      today.setHours(0, 0, 0, 0); // ตัดเวลาออกเพื่อความแม่นยำ

      let finalDate: Date;

      if (rawDate) {
        rawDate.setHours(0, 0, 0, 0);

        if (rawDate >= today) {
          // ถ้าเท่ากับหรือมากกว่าวันนี้ → บวกเพิ่ม 1 วัน
          finalDate = new Date(rawDate);
          finalDate.setDate(finalDate.getDate() + 1);
        } else {
          // ถ้าน้อยกว่าวันนี้ → ใช้วันนี้
          finalDate = today;
        }
      } else {
        finalDate = today;
      }

      // กำหนดค่า originalDate และ startDate
      this.originalDate = finalDate;
      this.startDate = finalDate;


      //   const rawDate = this.expire_date ? new Date(this.expire_date) : null;
      // const today = new Date();
      // today.setHours(0, 0, 0, 0);

      // let finalDate: Date;

      // if (rawDate) {
      //     rawDate.setHours(0, 0, 0, 0);

      //     if (rawDate >= today) {
      //         // ถ้าเท่ากับหรือมากกว่าวันนี้ → บวกเพิ่ม 1 วัน
      //         finalDate = new Date(rawDate);
      //         finalDate.setDate(finalDate.getDate() + 1);
      //     } else {
      //         // ถ้าน้อยกว่าวันนี้ → ใช้วันนี้
      //         finalDate = today;
      //     }
      // } else {
      //     finalDate = today;
      // }


      // // -----------------------------------------------------------
      // // ✅ จุดแก้ไข: แปลงเป็น Moment Object เพื่อให้วงกลมขึ้น
      // // -----------------------------------------------------------
      // // ตัวแปรนี้จะส่งไปให้ HTML แสดงผลวงกลมถูกต้อง และ Format จะเป็น dd/mm/yy ตามที่คุณตั้ง
      // this.startDate = new Date();

      // // ส่วน originalDate เก็บค่าแบบไหนก็ได้ตามที่คุณเอาไปใช้งานต่อ
      // // (ถ้าไม่ได้ใช้กับ datepicker เก็บเป็น Date ธรรมดาก็ได้)
      // this.originalDate = finalDate;


      const displayDate = new Date(finalDate);
      displayDate.setDate(displayDate.getDate() - 1); // ลดลง 1 วัน
      this.originalDate = displayDate;
      // แปลงเป็น string dd/MM/yyyy
      const day = displayDate.getDate().toString().padStart(2, '0');
      const month = (displayDate.getMonth() + 1).toString().padStart(2, '0');
      const year = displayDate.getFullYear();

      this.expire_date_show = `${day}/${month}/${year}`;

      this.showInfoPopup = true;
    }
    else {
      this.userStatus = false;
      this.vehicleId = 0;
      this.expire_date = '';
      this.disabled = true;
    }

    console.log("🚀 finalDate:", this.startDate, this.originalDate);
    console.log(
      'Check disabled : ',
      this.disabled_renew,
      this.disabled,
      this.cardCode
    );
  }
  ngOnInit(): void {
    // this.cookieService.set('line_uid', "U06c988e2a0431aa149672747eac92b41");
    const storedId = sessionStorage.getItem('providerId');
    const storedName = sessionStorage.getItem('providerName');
    this.providerId = storedId ? Number(storedId) : -1;
    this.providerName = storedName || '';
    this.uid =
      this.cookieService.get('line_uid') ||
      localStorage.getItem('line_uid') ||
      '';
    this.token =
      this.cookieService.get('token_user') ||
      localStorage.getItem('token_user') ||
      '';

    if (this.providerId === -1) {
      this.router.navigate(['/select-provider']);
    } else {
      this.getFeeDetails();
      setTimeout(() => {
        this.requestGetCarDetail();
        this.getApiAddressAll();
        this.checkFullTax();
        this.http
          .get<any[]>('json/thai_tambons.json')
          .subscribe((data) => {
            this.tambons = data;
            this.syncAddressSearchTexts();
          });
        this.http
          .get<any[]>('json/thai_amphures.json')
          .subscribe((data) => {
            this.amphures = data;
            this.syncAddressSearchTexts();
          });
        this.http
          .get<any[]>('json/thai_provinces.json')
          .subscribe((data) => {
            this.provincess = data;
            this.syncAddressSearchTexts();
          });
      }, 1000);
    }
  }
  // ================= Normal Functions =================

  // Custom Dropdown Getters and Helpers
  get filteredProvinceOptions() {
    const term = this.provinceSearchText?.trim().toLowerCase();
    if (!term) return this.provincess || [];
    return (this.provincess || []).filter(p => p.name_th?.toLowerCase().includes(term));
  }

  get filteredAmphureOptions() {
    const term = this.amphureSearchText?.trim().toLowerCase();
    if (!term) return this.filteredAmphures || [];
    return (this.filteredAmphures || []).filter(a => a.name_th?.toLowerCase().includes(term));
  }

  get filteredTambonOptions() {
    const term = this.tambonSearchText?.trim().toLowerCase();
    if (!term) return this.filteredTambons || [];
    return (this.filteredTambons || []).filter(t => t.name_th?.toLowerCase().includes(term));
  }

  get filteredPackageOptions() {
    // Field is read-only (select-like), always show the full list.
    return this.CardOptions || [];
  }

  selectAddressProvince(province: any) {
    this.selectedProvinceId = province.id;
    this.province_name = province.name_th;
    this.provinceSearchText = province.name_th;
    this.showProvinceDropdown = false;
    this.onProvinceChange();

    this.selectedAmphureId = null;
    this.amphure_name = '';
    this.amphureSearchText = '';
    this.selectedTambonId = null;
    this.tambon_name = '';
    this.tambonSearchText = '';
    this.zipcode = '';
  }

  selectAmphure(amphure: any) {
    this.selectedAmphureId = amphure.id;
    this.amphure_name = amphure.name_th;
    this.amphureSearchText = amphure.name_th;
    this.showAmphureDropdown = false;
    this.onAmphureChange();

    this.selectedTambonId = null;
    this.tambon_name = '';
    this.tambonSearchText = '';
    this.zipcode = '';
  }

  selectTambon(tambon: any) {
    this.selectedTambonId = tambon.id;
    this.tambon_name = tambon.name_th;
    this.tambonSearchText = tambon.name_th;
    this.showTambonDropdown = false;
    this.onTambonsChange();
  }

  selectPackage(option: any) {
    if (!this.selectVehicleType) {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณาเลือกประเภทยานพาหนะก่อน'
          : 'Please select a vehicle type first.'
      );
      return;
    }
    this.selectedOption = option.value;
    this.packageSearchText = option.label;
    this.showPackageDropdown = false;
    this.handlePackChange(option.value);
  }

  onPackageInputFocus() {
    if (!this.selectVehicleType) {
      this.showPackageDropdown = false;
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณาเลือกประเภทยานพาหนะก่อน เพื่อแสดงแพ็คเกจ'
          : 'Please select a vehicle type first to show packages.'
      );
      return;
    }
    this.showPackageDropdown = true;
  }

  closeProvinceDropdown() {
    setTimeout(() => {
      this.showProvinceDropdown = false;
      const matched = this.provincess?.find(p => p.name_th === this.provinceSearchText);
      if (matched) {
        if (this.selectedProvinceId !== matched.id) {
          this.selectAddressProvince(matched);
        }
      } else {
        const current = this.provincess?.find(p => p.id === this.selectedProvinceId);
        this.provinceSearchText = current ? current.name_th : '';
      }
    }, 150);
  }

  closeAmphureDropdown() {
    setTimeout(() => {
      this.showAmphureDropdown = false;
      const matched = this.filteredAmphures?.find(a => a.name_th === this.amphureSearchText);
      if (matched) {
        if (this.selectedAmphureId !== matched.id) {
          this.selectAmphure(matched);
        }
      } else {
        const current = this.filteredAmphures?.find(a => a.id === this.selectedAmphureId);
        this.amphureSearchText = current ? current.name_th : '';
      }
    }, 150);
  }

  closeTambonDropdown() {
    setTimeout(() => {
      this.showTambonDropdown = false;
      const matched = this.filteredTambons?.find(t => t.name_th === this.tambonSearchText);
      if (matched) {
        if (this.selectedTambonId !== matched.id) {
          this.selectTambon(matched);
        }
      } else {
        const current = this.filteredTambons?.find(t => t.id === this.selectedTambonId);
        this.tambonSearchText = current ? current.name_th : '';
      }
    }, 150);
  }

  closePackageDropdown() {
    setTimeout(() => {
      this.showPackageDropdown = false;
      const matched = this.CardOptions?.find(opt => opt.label === this.packageSearchText);
      if (matched) {
        if (this.selectedOption !== matched.value) {
          this.selectPackage(matched);
        }
      } else {
        const current = this.CardOptions?.find(opt => opt.value === this.selectedOption);
        this.packageSearchText = current ? current.label : '';
      }
    }, 150);
  }

  syncAddressSearchTexts() {
    if (this.provincess?.length && this.selectedProvinceId) {
      const p = this.provincess.find(x => x.id === this.selectedProvinceId);
      this.provinceSearchText = p ? p.name_th : '';
    }
    if (this.amphures?.length && this.selectedAmphureId) {
      const a = this.amphures.find(x => x.id === this.selectedAmphureId);
      this.amphureSearchText = a ? a.name_th : '';
    }
    if (this.tambons?.length && this.selectedTambonId) {
      const t = this.tambons.find(x => x.id === this.selectedTambonId);
      this.tambonSearchText = t ? t.name_th : '';
    }
  }

  syncPackageSearchText() {
    const current = this.CardOptions?.find(opt => opt.value === this.selectedOption);
    this.packageSearchText = current ? current.label : '';
  }

  /* --------------------------------------- Function -------------------------------- */
  /* --- Style --- */
  showWarning(text: string, detail: string = '') {
    // this.toast.warning(text);
    this.toastCustomService.showWarning('', text)
  }
  showError(text: string, detail: string = '') {
    // this.toast.error(text);
    this.toastCustomService.showError('', text)
  }
  showSuccess(text: string, detail: string = '') {
    // this.toast.success(text);
    this.toastCustomService.showSuccess(text, detail)
  }
  // Security
  handleCheckboxTaxChange(event: Event) {
    this.isRequestTax = (event.target as HTMLInputElement).checked;

    console.log('checkbox checked:', this.isRequestTax);
    // เพิ่ม logic ได้ที่นี่ เช่น เก็บค่าไว้ใน form
  }

  // Package
  validateForm() {
    const phoneValid = /^0[0-9]{9}$/.test(this.phoneNo);
    this.error = phoneValid ? '' : 'เบอร์ไม่ถูกต้อง';
  }

  handleCarChange(value: string): void {
    const selectedOption = this.CarOptions.find(
      (option) => option.value === value
    );
    if (selectedOption) {
      this.CardOptions = [];
      this.selectedOption = null;
      this.subscription_id = 0;
      console.log(`Selected CAR  ID: ${selectedOption.value}`);
      this.selectVehicleType = value; // อัปเดตค่า selectedRam เมื่อเลือก
      this.CardOptions = this.fullFeeList
        .filter((fee) => fee.vehicle_name === this.selectVehicleType)
        .map((fee) => ({
          value: fee.id,
          label: `${fee.name} ( ${fee.fee} บาท )`,
          fee: fee.fee + Number(fee.vat),
          fig_day: fee.fig_day,
          vehicle_type_name: fee.vehicle_name,
          subscription_id: fee.subscription_id,
        }));

      // Filter Vehicle plate list
      this.carPlateList = this.licenseAll.filter(
        (vehicle) => vehicle.vehicle_type_name === this.selectVehicleType
      );

      this.selectedOption = null;
      // console.log(
      //   'CardOptions',
      //   this.CardOptions,
      //   'selectVehicleType',
      //   this.selectVehicleType
      // );
      // console.log('selectedOption', this.selectedOption);
      this.updateBrandOptions(selectedOption.value, '');
      this.syncPackageSearchText();
    }
  }

  // VehicleType Form
  handleSelectVehicleType(vehicleType: string): void {
    const selectedOption = this.CarOptions.find(
      (option) => option.value === vehicleType
    );
    if (selectedOption) {
      this.CardOptions = [];
      this.selectedOption = null;
      this.subscription_id = 0;
      if (this.selectVehicleType !== vehicleType) {
        this.selectCarPlate = [];
        this.fig_day = 0;
        this.subscription_id = 0;
        this.fee = 0;
      }

      // console.log(`Selected CAR  ID: ${selectedOption.value}`);
      this.selectVehicleType = vehicleType; // อัปเดตค่า selectedRam เมื่อเลือก

      this.CardOptions = this.fullFeeList
        .filter((fee) => fee.vehicle_name === this.selectVehicleType)
        .map((fee) => ({
          value: fee.id,
          label: `${fee.name} ( ${fee.fee} บาท )`,
          fee: fee.fee + Number(fee.vat),
          fig_day: fee.fig_day,
          vehicle_type_name: fee.vehicle_name,
          subscription_id: fee.subscription_id,
        }));
      console.log('CardOptions', this.CardOptions, 'selectVehicleType', this.selectVehicleType);
      // Filter Vehicle plate list
      this.carPlateList = this.licenseAll.filter(
        (vehicle) => vehicle.vehicle_type_name === this.selectVehicleType
      );

      this.selectedOption = null;
      this.packageSearchText = '';
      this.showPackageDropdown = false;
      // console.log(
      //   'CardOptions',
      //   this.CardOptions,
      //   'selectVehicleType',
      //   this.selectVehicleType
      // );
      // console.log('selectedOption', this.selectedOption);
      this.updateBrandOptions(selectedOption.value, '');
      this.syncPackageSearchText();
    }
  }

  // Discount Code
  onChangeDiscountCodeType(event: any) {
    const discountCodeType = event;
    this.typeDiscountCode = discountCodeType;
    //console.log('typeDiscountCode : ', discountCodeType);
  }

  // Tax
  toggleModalTaxModal() {
    this.showTaxModal = !this.showTaxModal;
    if (!this.showTaxModal) {
      this.showAddressModal = false;
    }
  }
  toggleModalAddress() {
    this.showAddressModal = !this.showAddressModal;
  }
  selectAddress(item: MyAddressAllResponse) {
    this.selectedAddress = item;
    this.showAddressModal = false;
    this.setValueAddress();
  }

  // Vehicle Plate
  toggleSelect(vehicle: MyVehicleAllResponse, event: Event) {
    event.stopPropagation(); // ป้องกันไม่ให้ blur แล้ว dropdown ปิด
    console.log('vehicle', vehicle);
    const check = this.selectCarPlate.findIndex(plate =>
      plate.plate_number === vehicle.plate_number
    )
    // ตรวจสอบถ้ามีการเลือกแล้ว 1 รายการ
    if (this.selectCarPlate.length == 1 && check == -1) {
      return this.showWarning(
        this.currentLang === 'TH'
          ? 'คุณสามารถเลือกไม่เกิน 1 ทะเบียน'
          : 'You can select up to 1 plate.'
      );
    }

    const index = this.selectCarPlate
      .map((item) => item.plate_number)
      .indexOf(vehicle.plate_number);

    if (index > -1) {
      this.selectCarPlate.splice(index, 1);
    } else {
      // เพิ่ม Model ลงใน selectCarPlate
      this.selectCarPlate.push(vehicle);

      console.log('✅ Selected Plates:', this.selectCarPlate);
    }
  }
  isSelected(plate: string): boolean {
    return this.selectCarPlate.map((item) => item.plate_number).includes(plate);
  }
  toggleModalVehiclePlate() {
    this.showModalVehiclePlate = !this.showModalVehiclePlate;
  }

  // Modal
  closeModal_Confirm() {
    this.showModal_confirm = false;
  }

  // // Modal Vehicle Plate
  // toggleOpenSelectVehicleProvince() {
  //   this.isOpenSelectVehiclePlateModal = !this.isOpenSelectVehiclePlateModal;
  // }


  /* --- Function --- */
  // Security
  filterNumberOnly(event: Event) {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^0-9]/g, '');
    this.phoneNo = input.value;
  }

  filterTaxIdOnly(event: Event) {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^0-9]/g, '');
    this.taxId = input.value;
  }

  filterTaxPhoneOnly(event: Event) {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^0-9]/g, '');
    this.tax_phone = input.value;
  }

  // Register Form
  submitRequest() {
    console.log(this.startDate);
    if (!this.startDate) {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณาระบุวันที่เริ่มต้นใช้งาน'
          : 'Please specify the start date.'
      );
    } else if (this.selectVehicleType == '') {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณาเลือกประเภทรถ'
          : 'Please select the vehicle type.'
      );
    } else if (!this.selectedOption) {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณาเลือกแพ็คเกจ'
          : 'Please select a package.'
      );
    } else if (!this.customer_name.trim()) {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณาระบุชื่อผู้สมัคร'
          : 'Please specify full name.'
      );
    } else if (!this.phoneNo.trim()) {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณาระบุเบอร์โทรศัพท์'
          : 'Please specify the phone number.'
      );
    } else if (this.selectCarPlate.length == 0) {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณาระบุทะเบียนรถ'
          : 'Please specify the vehicle plate.'
      )
    }
    else if (this.isRequestTax) {
      if (
        !this.taxName.trim() &&
        !this.taxId.trim() &&
        !this.address.trim() &&
        this.selectedProvinceId === null &&
        this.selectedAmphureId === null &&
        this.selectedTambonId === null
      ) {
        this.showWarning(
          this.currentLang === 'TH'
            ? 'กรุณาเพิ่มข้อมูลใบกำกับภาษีก่อน'
            : 'Please add the tax invoice details first.'
        );
      } else if (!this.taxName.trim()) {
        this.showWarning(
          this.currentLang === 'TH'
            ? 'กรุณาระบุชื่อผู้เสียภาษี'
            : 'Please enter the full name of the taxpayer'
        );
      } else if (
        !this.branchName.trim() &&
        !this.branchNo.trim() &&
        !this.mainOffice &&
        this.selectedTaxType === '2'
      ) {
        this.showWarning(
          this.currentLang === 'TH'
            ? 'กรุณาระบุสาขาและรหัสสาขา'
            : 'Please enter the branch code'
        );
      } else if (!this.taxId.trim()) {
        this.showWarning(
          this.currentLang === 'TH'
            ? 'กรุณาระบุเลขประจำตัวผู้เสียภาษี'
            : 'Please enter a valid taxpayer identification number.'
        );
      } else if (!this.address.trim()) {
        this.showWarning(
          this.currentLang === 'TH'
            ? 'กรุณาระบุที่อยู่'
            : 'Please enter a valid address.'
        );
      } else if (!this.tax_phone.trim()) {
        this.showWarning(
          this.currentLang === 'TH'
            ? 'กรุณาระบุเบอร์โทรศัพท์ในใบกำกับภาษี'
            : 'Phone number is required for issuing the tax invoice.'
        );
      } else if (this.selectedProvinceId === null) {
        this.showWarning(
          this.currentLang === 'TH'
            ? 'กรุณาระบุจังหวัด'
            : 'Please select a province.'
        );
      } else if (this.selectedAmphureId === null) {
        this.showWarning(
          this.currentLang === 'TH'
            ? 'กรุณาระบุอำเภอ'
            : 'Please select a district.'
        );
      } else if (this.selectedTambonId === null) {
        this.showWarning(
          this.currentLang === 'TH'
            ? 'กรุณาระบุตำบล'
            : 'Please select a sub district.'
        );
      } else if (!this.zipcode) {
        this.showWarning(
          this.currentLang === 'TH'
            ? 'กรุณาระบุรหัสไปรษณีย์'
            : 'Please enter a postal code'
        );
      } else {
        if (this.vehicleId > 0) {
          if (this.originalDate && this.startDate) {
            const original = new Date(this.originalDate);
            const start = new Date(this.startDate);
            original.setHours(0, 0, 0, 0);
            start.setHours(0, 0, 0, 0);
            if (start > original) {
              this.showModal_confirm = true;
            } else {
              this.showWarning(
                this.currentLang === 'TH'
                  ? 'วันที่เริ่มจะต้องมากกว่าวันหมดอายุเดิม'
                  : 'Please ensure the start date is after the previous expiration date.'
              );
            }
          } else {
            this.showError(
              this.currentLang === 'TH'
                ? 'การตรวจสอบวันเริ่มใช้งานมีปัญหา'
                : 'An issue occurred while validating the start date.'
            );
          }
        } else {
          this.showModal_confirm = true;
        }
      }
    } else {
      console.log('No Tax !');
      if (this.vehicleId > 0) {
        if (this.originalDate && this.startDate) {
          const original = new Date(this.originalDate);
          const start = new Date(this.startDate);
          original.setHours(0, 0, 0, 0);
          start.setHours(0, 0, 0, 0);
          if (start > original) {
            this.showModal_confirm = true;
          } else {
            this.showWarning(
              this.currentLang === 'TH'
                ? 'วันที่เริ่มจะต้องมากกว่าวันหมดอายุเดิม'
                : 'Start date must be after the previous expiry date.'
            );
          }
        } else {
          this.showError(
            this.currentLang === 'TH'
              ? 'การตรวจสอบวันเริ่มใช้งานมีปัญหา'
              : 'An issue occurred while validating the start date.'
          );
        }
      } else {
        this.showModal_confirm = true;
      }
    }
  }

  // Package
  handlePackChange(value: number | string): void {
    const numericValue =
      typeof value === 'string' ? parseInt(value, 10) : value;
    // console.log('🔄 handlePackChange:', numericValue);

    const selected = this.CardOptions.find(
      (option) => option.value === numericValue
    );
    console.log('🎯 selectedOption:', selected);
    this.selectedOption = numericValue;
    if (selected) {
      console.log(this.fee);
      console.log(selected.fee);
      this.fig_day = selected.fig_day;
      this.subscription_id = selected.subscription_id;
      this.fee = selected.fee - 1;
      console.log(this.fee);
      // console.log('✅ Selected Option ID:', numericValue);
      // console.log('📆 Selected FigDay:', this.fig_day);
      // console.log('📆 Selected subscription:', this.subscription_id);
    } else {
      this.fig_day = null;
      // console.warn('⚠️ ไม่พบ option ที่เลือก');
    }
  }

  //Vehicle Plate
  filterCarPlate(event: any) {
    const searchTerm = event.target.value.toLowerCase();
    this.carFilteredPlateList = this.carPlateList.filter((vehicle) =>
      vehicle.plate_number.toLowerCase().includes(searchTerm)
    );
  }

  addVehiclePlate(vehicle: MyVehicleAllResponse) {
    this.carPlateList.push(vehicle);
  }
  calVehicleTotal() {
    this.total = (this.fee ?? 0) * (this.selectCarPlate?.length ?? 0) || 0;

    if (!this.cityparkingDiscountByCode) return this.total;

    // ตรวจสอบประเภทส่วนลด
    /*-- เงิน --*/
    if (this.cityparkingDiscountByCode.type == false) {
      // ตรวจสอบจำนวนเงิน
      const totalDiscount = (this.total ?? 0) - this.cityparkingDiscountByCode.amount;
      this.discountPrice = this.total - totalDiscount
      if (totalDiscount > 0) {
        return totalDiscount;
      } else {
        return 0;
      }

    }
    /*-- เปอร์เซ็น --*/
    else {
      const percent = Number(this.cityparkingDiscountByCode.amount) || 0;

      // ถ้าเปอร์เซ็นต์ไม่ถูกต้อง ให้คืนค่าเดิม
      if (percent <= 0) return this.total;

      // ป้องกันเปอร์เซ็นต์เกิน 100
      const clampedPercent = Math.max(0, Math.min(percent, 100));

      // คำนวณส่วนลด และปัดทศนิยม 2 ตำแหน่ง
      const discounted = this.total * (1 - clampedPercent / 100);
      const result = Math.max(0, Math.round(discounted * 100) / 100);

      this.discountPrice = this.total - result;
      return result;
    }
  }


  // Modal Vehicle Plate
  filterProvinces() {
    return this.ProvinceOptions.filter((ProvinceOptions) =>
      ProvinceOptions.label
        .toLowerCase()
        .includes(this.searchTerm.toLowerCase())
    );
  }
  selectProvince(province: any) {
    this.selectedProvince = province;
    this.isOpenSelectVehicleProvince = false;
    // console.log('เลือกจังหวัด:', province);
  }
  handleBrandChange(event: any): void {
    this.selectedBrand = event.target.value;
    console.log('Selected Brand ID:', this.selectedBrand);
    this.updateModelOptions(this.selectedBrand || '');
  }
  updateModelOptions(brand: string): void {
    // กรองข้อมูลตามประเภทที่เลือก
    const filteredModel = this.vehicleDetails
      .filter(
        (brands) =>
          brands.vehicle_brand_name === brand &&
          brands.vehicle_type_name === this.selectVehicleType
      ) // กรองตามประเภทที่เลือก
      .map((brands) => brands.vehicle_model_name); // ดึงแค่ vehicle_brand_name

    // กรองค่าซ้ำจาก filteredBrands
    const uniqueBrands = [...new Set(filteredModel)];
    this.selectedModel = '';
    this.selectEngine = '';
    // อัปเดต BrandOptions โดยใช้ค่าที่ไม่ซ้ำดอ
    this.ModelOptions = uniqueBrands.map((model) => ({
      value: model,
      label: model,
    }));
  }
  handleModelChange(event: any): void {
    this.selectedModel = event.target.value;
    this.selectEngine = '';
    console.log('Selected Model ID:', this.selectedModel);

    const filteredEngines = this.vehicleDetails
      .filter(
        (brands) =>
          brands.vehicle_brand_name === this.selectedBrand &&
          brands.vehicle_type_name === this.selectVehicleType &&
          brands.vehicle_model_name === this.selectedModel
      ) // กรองตามประเภทที่เลือก
      .map((brands) => brands.vehicle_engine_name);

    this.selectEngine = filteredEngines[0] || '';
    console.log('Selected Engine:', this.selectEngine);
  }
  handleColorChange(event: any): void {
    this.selectedColor = event.target.value;
    console.log('Selected Color ID:', this.selectedColor);
    // this.updateModelOptions(this.selectedBrand || '');
  }
  validateLicense(): void {
    const pattern = /^(\d?[ก-ฮ]{1,3})\s?\d{1,4}$/;
    const isValid = pattern.test(this.license.trim());

    if (!isValid) {
      this.licenseError =
        this.currentLang === 'TH'
          ? 'รูปแบบทะเบียนไม่ถูกต้อง (ตัวอักษรไทย 1-3 ตัว + เลข 1-4 หลัก)'
          : 'Invalid license plate format (1-3 Thai characters + 1-4 digits)';
    } else {
      this.licenseError = null;
    }
  }
  submitModalVehiclePlate() {
    // console.log('License:', this.license);
    if (!this.selectVehicleType) {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณาเลือกประเภทยานพาหนะ'
          : 'Please specify the vehicle type.'
      );
    } else if (!this.license || this.licenseError) {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณากรอกทะเบียนรถ'
          : 'Please specify the vehicle registration.'
      );
    } else if (this.selectedProvince == null) {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณาระบุจังหวัด'
          : 'Please specify the province.'
      );
    }
    // else if (this.selectedBrand == '') {
    //   this.showWarning(
    //     this.currentLang === 'TH'
    //       ? 'กรุณาเลือกยี่ห้อ'
    //       : 'Please select the brand.'
    //   );
    // }
    // else if (this.selectedModel == '') {
    //   this.showWarning(
    //     this.currentLang === 'TH'
    //       ? 'กรุณาเลือกรุ่น'
    //       : 'Please select the model.'
    //   );
    // }
    // else if (this.selectedColor == '') {
    //   this.showWarning(
    //     this.currentLang === 'TH'
    //       ? 'กรุณาเลือกสีของรถ'
    //       : 'Please select the color.'
    //   );
    // }
    else {
      const payload: InsertLicensePayload = {
        uid: this.uid,
        license: this.license.replace(/\s+/g, ''),
        vehicle_type: this.selectVehicleType || '',
        brand: /*this.selectedBrand ||*/ this.selectVehicleType == "รถยนต์" ? 'Acura' : 'Honda',
        model: /*this.selectedModel ||*/ this.selectVehicleType == "รถยนต์" ? 'Integra' : 'ADV160',
        engine_type: this.selectEngine || '',
        color: /*this.selectedColor || */this.selectVehicleType == "รถยนต์" ? 'ดำ' : 'ดำ',
        province: this.selectedProvince.value,
      };
      if (payload) {
        // console.log('payload', JSON.stringify(payload, null, 2));
        this.apiLicenseService.insertLicense(payload, this.token).subscribe({
          next: (res: InsertLicenseResponse) => {
            console.log('📦 Response:', res);
            if (res.code == '000') {
              this.isSaveLoading = false;
              this.getVehicleUser();
              this.showSuccess(
                this.currentLang === 'TH'
                  ? 'บันทึกสำเร็จ'
                  : 'Saved successfully.'
                , this.currentLang === 'TH'
                  ? 'เพิ่มข้อมูลทะเบียนรถของคุณเรียบร้อย'
                  : 'Successfully added vehicle registration.'
              );
              this.showModalVehiclePlate = false;
            } else {
              this.showError(
                this.currentLang === 'TH'
                  ? 'บันทึกไม่สำเร็จ'
                  : 'Save not successful.'
              );
            }
          },
          error: (err) => {
            console.error('❌ ส่ง OTP ไม่สำเร็จ:', err);
            this.showError(
              this.currentLang === 'TH'
                ? 'บันทึกไม่สำเร็จ'
                : 'Save not successful.'
            );
            this.isSaveLoading = false;
          },
          complete: () => {
            this.isSaveLoading = false;
          },
        });
      } else {
        console.log('No payload Data');
      }
    }
  }

  // Modal Vehicle Select Plate
  changeLicense(plate: string) {
    // console.log('plate', plate);
    // this.license = plate;
    this.modalSelectVehicle = false;
    const selectedVehicle = this.licenseAll.find(
      (item) => item.plate_number === plate
    );

    if (selectedVehicle) {
      // console.log('✅ ข้อมูลรถที่เลือก:', selectedVehicle);
      this.changeUpdateOptionCar(
        selectedVehicle.province_name,
        selectedVehicle.vehicle_type_name,
        selectedVehicle.color_name,
        selectedVehicle.brand_name,
        selectedVehicle.model_name
      );
    } else {
      console.log('❌ ไม่พบทะเบียน:', plate);
    }
  }
  changeUpdateOptionCar(
    province_name: string,
    vehicle_type_name: string,
    color_name: string,
    brand_name: string,
    model_name: string
  ) {
    if (!this.licenseAll || this.licenseAll.length === 0) {
      console.log('❌ ไม่มีข้อมูลรถ');
      return;
    }

    // 🏷️ จังหวัด
    const matchProvince = this.ProvinceOptions.find(
      (p) => p.value === province_name
    );
    if (matchProvince) {
      this.selectedProvince = matchProvince;
    }

    // 🚗 ประเภทรถ
    const defaultCar = this.CarOptions.find(
      (opt) => opt.value === vehicle_type_name
    );
    // this.selectVehicleType = defaultCar ? defaultCar.value : '';

    // 💳 ค่าบริการ
    this.CardOptions = this.fullFeeList
      .filter((fee) => fee.vehicle_name === this.selectVehicleType)
      .map((fee) => ({
        value: fee.id,
        label: `${fee.name} ( ${fee.fee} บาท )`,
        fee: fee.fee + Number(fee.vat),
        fig_day: fee.fig_day,
        vehicle_type_name: fee.vehicle_name,
        subscription_id: fee.subscription_id,
      }));

    // 🏷️ อัปเดตยี่ห้อรถ และตั้งค่า selectedBrand
    this.updateBrandOptions(this.selectVehicleType || '', brand_name);

    // ✅ model ต้องรอ selectedBrand ถูก set แล้ว จึงค่อยเรียก updateModelOptions
    if (brand_name) {
      const brandExists = this.BrandOptions.find(
        (opt) => opt.value === brand_name
      );
      this.selectedBrand = brandExists ? brandExists.value : null;

      // ✅ เรียกหลังจาก selectedBrand ถูกตั้งค่าแล้ว
      this.updateModelOptions(this.selectedBrand || '');
      const defaultModel = this.ModelOptions.find(
        (opt) => opt.value === model_name
      );
      this.selectedModel = defaultModel ? defaultModel.value : null;
    }

    // 🎨 สี
    const defaultColor = this.ColorOptions.find(
      (opt) => opt.value === color_name
    );
    this.selectedColor = defaultColor ? defaultColor.value : null;
  }
  updateBrandOptions(vehicleType: string, preselectBrand?: string): void {
    const filteredBrands = this.vehicleDetails
      .filter((vehicle) => vehicle.vehicle_type_name === vehicleType)
      .map((vehicle) => vehicle.vehicle_brand_name);

    const uniqueBrands = [...new Set(filteredBrands)];
    this.selectedBrand = '';
    this.selectedModel = '';

    this.BrandOptions = uniqueBrands.map((brand) => ({
      value: brand,
      label: brand,
    }));

    // ✅ ถ้ามีค่าที่ต้องการเลือกไว้ล่วงหน้า
    if (preselectBrand) {
      // console.log('เลือกแบร์นมา ', preselectBrand);
      const defaultBrand = this.BrandOptions.find(
        (opt) => opt.value === preselectBrand
      );
      this.selectedBrand = defaultBrand ? defaultBrand.value : null;
    }
  }

  // Discount code
  onChangeDiscountCode(event: any) {
    const discountCode = event;
    this.discountCode = discountCode;

    //console.log('discountCode : ', discountCode);
  }
  activeCode() {
    if (!this.discountCode || this.discountCode === '') {
      return this.showWarning('กรุณาระบุรหัสส่วนลด');
    }
    this.getApiDiscountCode();
  }
  deleteCode() {
    this.discountCode = '';
    this.disableDiscountCode = false;
    this.cityparkingDiscountByCode = null;
    this.calVehicleTotal();
  }


  // Tax
  filterAddressByTaxType(): void {
    this.filteredAddressList = [];
    this.selectedAddress = null;
    this.address_id = 0;
    const type = parseInt(this.selectedTaxType, 10); // แปลงเป็น number
    this.filteredAddressList = this.addressListAll.filter(
      (item) => item.address_user_type === type
    );
    if (this.filteredAddressList.length > 0) {
      this.showSelectAddress = true;
      this.selectedAddress = this.filteredAddressList[0];
      this.setValueAddress();
    } else {
      this.showSelectAddress = false;
      this.selectedAddress = null;
      this.setValueAddress();
    }
  }
  setValueAddress() {
    if (this.selectedAddress) {
      this.address_id = this.selectedAddress.id;
      this.mainOffice = this.selectedAddress.headquarters;
      this.taxName = this.selectedAddress.name;
      this.tax_phone = this.selectedAddress.phone;
      this.email = this.selectedAddress.email;
      this.branchName = this.selectedAddress.branch;
      this.branchNo = this.selectedAddress.branch_no;
      this.taxId = this.selectedAddress.tax_id;
      this.address = this.selectedAddress.address;
      this.tax_phone = this.selectedAddress.phone;

      const selectedProvName = this.selectedAddress?.provinces?.trim() ?? '';
      const matchedProvince = this.provincess.find(
        (p) => p.name_th.trim() === selectedProvName
      );
      if (matchedProvince) {
        this.selectedProvinceId = matchedProvince.id;
        this.province_name = selectedProvName;
      } else {
        this.selectedProvinceId = null;
        this.province_name = '';
      }

      if (this.selectedProvinceId != null) {
        const provinceId = this.selectedProvinceId;
        this.filteredAmphures = this.amphures.filter(
          (a) => a.province_id === +provinceId
        );

        const selectedAmphureName =
          this.selectedAddress?.district?.trim() ?? '';
        const matchedAmphure = this.filteredAmphures.find(
          (a) => a.name_th.trim() === selectedAmphureName
        );
        if (matchedAmphure) {
          this.selectedAmphureId = matchedAmphure.id;
          this.amphure_name = selectedAmphureName;
        } else {
          this.selectedAmphureId = null;
          this.amphure_name = '';
        }
      } else {
        this.filteredAmphures = [];
        this.selectedAmphureId = null;
        this.amphure_name = '';
      }

      if (this.selectedAmphureId != null) {
        const amphureId = this.selectedAmphureId;

        // กรองตำบลในอำเภอที่เลือก
        this.filteredTambons = this.tambons.filter(
          (a) => a.amphure_id === +amphureId
        );

        // ดึงชื่อจากที่อยู่
        const selectedTambonName =
          this.selectedAddress?.sub_district?.trim() ?? '';

        // หาใน list ว่าตรงกับตำบลไหน
        const matchedTambon = this.filteredTambons.find(
          (a) => a.name_th.trim() === selectedTambonName
        );

        if (matchedTambon) {
          this.selectedTambonId = matchedTambon.id;
          this.tambon_name = selectedTambonName;
          this.zipcode = this.selectedAddress.zip_code;
        } else {
          this.selectedTambonId = null;
          this.tambon_name = '';
          this.zipcode = '';
        }
      } else {
        this.filteredTambons = [];
        this.selectedTambonId = null;
        this.tambon_name = '';
      }
      this.syncAddressSearchTexts();
    } else {
      // ✅ ล้างค่าเมื่อไม่มี selectedAddress
      this.address_id = 0;
      this.mainOffice = false;
      this.taxName = '';
      this.tax_phone = '';
      this.email = '';
      this.branchName = '';
      this.branchNo = '';
      this.taxId = '';
      this.address = '';
      this.zipcode = '';
      this.selectedProvinceId = null;
      this.province_name = '';
      this.filteredAmphures = [];

      this.selectedAmphureId = null;
      this.amphure_name = '';
      this.filteredTambons = [];
      this.syncAddressSearchTexts();
    }
  }
  getAddressByTaxId() {
    if (!this.taxId.trim()) {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณาระบุเลขผู้เสียภาษีก่อน'
          : 'Please enter your taxpayer identification number first.'
      );
    } else {
      //this.isLoading = true;
      this.ApigetAddressByTaxId();
    }
  }
  onProvinceChange() {
    // console.log(this.selectedProvinceId);
    this.selectedAmphureId = null;
    this.selectedTambonId = null;
    this.zipcode = '';
    this.amphure_name = '';
    this.tambon_name = '';
    this.filteredAmphures =
      (this.selectedProvinceId ?? null) !== null
        ? this.amphures.filter(
          (a) => a.province_id === +this.selectedProvinceId!
        )
        : [];
    if (this.provincess.length && this.selectedProvinceId) {
      const province = this.provincess.find(
        (a) => a.id === Number(this.selectedProvinceId)
      );
      this.province_name = province ? province.name_th : '';
      // console.log('✅ province_name:', this.province_name);
    } else {
      console.warn('⚠️ province list or selectedProvinceId not ready');
    }

    this.filteredTambons = []; // reset
  }
  onAmphureChange() {
    this.selectedTambonId = null;
    this.zipcode = '';
    this.tambon_name = '';
    this.filteredTambons =
      (this.selectedAmphureId ?? null) !== null
        ? this.tambons.filter((a) => a.amphure_id === +this.selectedAmphureId!)
        : [];
    if (this.amphures.length && this.selectedAmphureId) {
      const amphure = this.amphures.find(
        (a) => a.id === Number(this.selectedAmphureId)
      );
      this.amphure_name = amphure ? amphure.name_th : '';
      // console.log('✅ amphure_name:', this.amphure_name);
    }
  }
  onTambonsChange() {
    // console.log(this.selectedTambonId);
    this.zipcode = '';
    this.zipcode =
      (this.selectedTambonId ?? null) !== null
        ? this.tambons.filter((t) => t.id === +this.selectedTambonId!)[0]
          ?.zip_code || ''
        : '';

    if (this.tambons.length && this.selectedTambonId) {
      const tambon = this.tambons.find(
        (a) => a.id === Number(this.selectedTambonId)
      );
      this.tambon_name = tambon ? tambon.name_th : '';
      // console.log(this.tambon_name);
    }
  }
  submitTax() {
    const detectTaxId = (value: string): boolean => {
      return /^\d+$/.test(value) && !isNaN(Number(value));
    };

    if (!this.taxName.trim()) {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณาระบุชื่อผู้เสียภาษี'
          : 'Please enter the full name of the taxpayer'
      );
    } else if (
      !this.branchName.trim() &&
      !this.branchNo.trim() &&
      !this.mainOffice &&
      this.selectedTaxType === '2'
    ) {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณาระบุสาขาและรหัสสาขา'
          : 'Please enter the branch code'
      );
    } else if (!this.taxId.trim()) {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณาระบุเลขประจำตัวผู้เสียภาษี'
          : 'Please enter a valid taxpayer identification number.'
      );
    } else if (!detectTaxId(this.taxId) || this.taxId.length !== 13) {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณาตรวจสอบเลขประจำตัวผู้เสียภาษีให้ถูกต้อง'
          : 'Please check the taxpayer identification number.'
      );
    }
    // else if (!this.tax_phone.trim()) {
    //   this.showWarning(
    //     this.currentLang === 'TH'
    //       ? 'กรุณาระบุเบอร์โทรศัพท์ในใบกำกับภาษี'
    //       : 'Phone number is required for issuing the tax invoice.'
    //   );
    // }
    else if (!this.address.trim()) {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณาระบุที่อยู่'
          : 'Please enter a valid address.'
      );
    } else if (this.selectedProvinceId === null) {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณาระบุจังหวัด'
          : 'Please select a province.'
      );
    } else if (this.selectedAmphureId === null) {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณาระบุอำเภอ'
          : 'Please select a district.'
      );
    } else if (this.selectedTambonId === null) {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณาระบุตำบล'
          : 'Please select a sub district.'
      );
    } else if (!this.zipcode) {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณาระบุรหัสไปรษณีย์'
          : 'Please enter a postal code'
      );
    } else {
      this.showTaxModal = false;
    }
  }
  goBack() {
    setTimeout(() => {
      this.router.navigate(['/home']);
    }, 0);
  }

  /* ---------------------------------------- API ----------------------------------------------- */
  // Form
  saveMemberRegister() {
    this.closeModal_Confirm();
    this.isSaveLoading = true;
    this.token = this.cookieService.get('token_user');

    const date = new Date(this.startDate || '');
    date.setHours(date.getHours() + 7);

    const carListModel: CarList[] = this.selectCarPlate.map((item) => ({
      vehicleId: item.vehicle_id,
      license: item.plate_number,
      province: item.province_name,
      vehicleTypeId: this.selectVehicleType,
    }));
    if (!carListModel) {
      console.log('carListModel os null');
    }
    const payload: RegisterMemberNewPayload = {
      uid: this.uid,
      name: this.customer_name,
      member_start: date,
      phone: this.phoneNo,
      license: this.license.replace(/\s+/g, ''),
      vehicle_type: this.selectVehicleType,
      brand: '',
      model: '',
      color: '',
      province: '',
      remark: this.remarks,
      full_tax: this.isRequestTax,
      full_name: this.taxName,
      address_id: this.address_id,
      address_user_type: parseInt(this.selectedTaxType || '0', 10),
      address: this.address || '',
      sub_district: this.tambon_name || '',
      district: this.amphure_name || '',
      provinces: this.province_name || '',
      zip_code: this.zipcode || '',
      email: this.email || '',
      branch: this.branchName || '',
      branch_no: this.branchNo || '',
      headquarters: this.mainOffice,
      site_id: this.providerId,
      fee_id: this.selectedOption || 0,
      fig_day: this.fig_day,
      subscription_id: this.subscription_id,
      taxId: this.taxId,
      is_default: false,
      register_member_type: this.cardCode ? 2 : 1,
      phone_tax: this.tax_phone,
      memberVehicles: carListModel,
      discountCode: this.discountCode
    };

    console.log(JSON.stringify(payload).toString());
    if (payload) {
      this.isLoading = true;
      this.apiMemberCardService.RegisterMemberCard(payload, this.token).subscribe({
        next: (res: StatusAPIResponse) => {
          this.isLoading = false;
          console.log('📦 Response:', res);
          if (res.code == '000') {
            this.isSaveLoading = false;
            // this.showSuccess(
            //   this.currentLang === 'TH'
            //     ? 'สมัครสมาชิกเรียบร้อยแล้ว'
            //     : 'Registration completed successfully.'
            // );
            setTimeout(() => {
              this.router.navigate(['/payment-services'], {
                state: {
                  isSuccess: {
                    text: this.disabled ? 'ต่ออายุเรียบร้อยแล้ว' : 'สมัครเรียบร้อยแล้ว!',
                    details: 'โปรดชำระค่าบริการสมัครสมาชิกภายใน 24 ชม',
                    result: true
                  }

                },
              });
            }, 0);
            //this.clearData();
          } else {
            this.showError(res.message);
          }
        },
        error: (err) => {
          this.isLoading = false;
          console.error('❌  ไม่สำเร็จ:', err);
          this.showError(
            this.currentLang === 'TH'
              ? 'สมัครสมาชิกไม่สำเร็จ'
              : 'Registration was not completed.'
          );
          this.isSaveLoading = false;
        },
        complete: () => {
          this.isSaveLoading = false;
        },
      });
    } else {
      console.log('payload os null');
    }
  }
  setValueVehicle(response: MyVehicleAllResponse[]) {
    // --- กรองข้อมูลทะเบียนรถ ---
    this.licenseAll = response;

    // ใส่ป้ายทะเบียนเริ่มต้น
    this.carPlateList = this.licenseAll.filter(
      (item) => item.vehicle_type_name === this.selectVehicleType
    );

    // console.log('this.licenseAll', this.licenseAll);

    // --- เลือกทะเบียนรถ ---
    // if (this.licenseAll.length > 0) {
    //   if (this.vehicleId > 0) {
    //     console.log('vehicleId', this.vehicleId);
    //     const found = this.licenseAll.find(
    //       (item) => item.vehicle_id === this.vehicleId
    //     );
    //     // if (found) {
    //     //   console.log('found', found.plate_number);
    //     //   this.selectedLicense = found.plate_number;
    //     //   // this.license = found.plate_number;
    //     //   this.changeLicense(this.selectedLicense);
    //     // } else {
    //     //   // fallback ถ้าไม่เจอ
    //     //   this.selectedLicense = this.licenseAll[0].plate_number;
    //     //   this.changeLicense(this.selectedLicense);
    //     // }
    //   } else {
    //     // this.selectedLicense = this.licenseAll[0].plate_number;
    //     this.changeLicense(this.selectedLicense);
    //   }
    // }
  }

  requestGetCarDetail() {
    this.isLoading = true;
    // console.log('Token:', this.token);
    this.apiVehicleService.getCarDetail(this.token).subscribe({
      next: (response: InformationResponse) => {
        // console.log('getCarDetail :', response);
        this.vehicleDetails = response.vehicle_detail;
        this.ColorOptions = response.color.map((color: Color) => ({
          value: color.name.toLowerCase(),
          label: color.name,
        }));
        this.ProvinceOptions = response.province.map((province: Province) => ({
          value: province.name.toLowerCase(),
          label: province.name,
        }));

        this.CarOptions = [
          ...new Set(
            response.vehicle_detail.map((vehicleDetail: VehicleDetail) =>
              vehicleDetail.vehicle_type_name.toLowerCase()
            )
          ),
        ].map((vehicleTypeName: string) => ({
          value: vehicleTypeName,
          label:
            vehicleTypeName.charAt(0).toUpperCase() + vehicleTypeName.slice(1), // แสดงผลให้เป็นตัวพิมพ์ใหญ่ที่ตัวแรก
        }));
        // console.log('Set CarOptions:', this.CarOptions, this.selectVehicleType);
        this.getVehicleUser();
        this.isLoading = false;
      },
      error: (error) => {
        console.error('API error:', error);
        this.isLoading = false;
      },
    });
  }

  getVehicleUser() {
    console.log('getVehicleUser');
    setTimeout(() => {
      this.getProgile();
      if (!this.cardCode) {
        this.getUserVehicleAll();
      } else {
        // vehicleType
        this.getUserVehicleAllByCardCode();
      }
    }, 100);
  }

  getApiAddressAll() {
    this.address_id = 0;
    this.apiMemberService.getMyAddress(this.token, this.uid).subscribe({

      next: (response: MyAddressAllResponse[]) => {
        console.log('getApiAddressAll');
        console.log('response', response);
        this.addressListAll = response;
        this.selectedAddress = null;
        // ✅ เลือกแถวแรกอัตโนมัติแบบง่าย
        if (this.addressListAll.length > 0) {
          this.showSelectAddress = true;

          const type = 1; // แปลงเป็น number
          this.filteredAddressList = this.addressListAll.filter(
            (item) => item.address_user_type === type
          );
          this.selectedAddress = this.filteredAddressList[0];
          this.setValueAddress();
        } else {
          this.showSelectAddress = false;
        }
      },
      error: (error) => {
        console.error('API error:', error);
        this.isLoading = false;
      },
    });
  }
  checkFullTax() {
    this.apiMemberService.checkFullTax(this.token, this.uid).subscribe({
      next: (response: StatusAPIResponse) => {
        if (response) {
          if (response.code === '000') this.isRequestTax = true;
          else this.isRequestTax = false;
        } else {
          this.isRequestTax = false;
        }
      },
      error: (error) => {
        console.error('API error:', error);
      },
    });
  }
  getFeeDetails() {
    this.apiMemberService.getFeeDetails(this.providerId).subscribe({
      next: (response: ObjectFeeResponse) => {
        console.log('fee : ', response);
        this.fullFeeList = response.feeDetail;
        this.CardOptions = []; // เริ่มต้นว่างก่อนรอเลือกประเภทรถ
      },
      error: (error) => {
        console.error('API error:', error);
      },
    });
  }

  getUserVehicleAll() {
    this.apiVehicleService
      .getVehicleUserAllBySite(this.token, this.uid, this.providerId)
      .subscribe({
        next: (response: MyVehicleAllResponse[]) => {
          // console.log('response getVehicleUserAll : ', response);
          this.setValueVehicle(response);
        },
        error: (error) => {
          console.error('API error:', error);
          this.showError(
            this.currentLang === 'TH'
              ? 'ไม่พบข้อมูลรถ'
              : 'Not found vehicle data'
          );
          this.isLoading = false;
        },
      });
  }

  getUserVehicleAllByCardCode() {
    this.apiVehicleService
      .getVehicleMemberInfo(
        this.token,
        this.uid,
        this.providerId,
        this.cardCode
      )
      .subscribe({
        next: (response: MyVehicleAllResponse[]) => {
          this.setValueVehicle(response);

          response.forEach((vehicle) => {
            this.selectCarPlate.push(vehicle);
          });

          this.handleSelectVehicleType(this.selectVehicleType);
        },
        error: (error) => {
          console.error('API error:', error);
          this.isLoading = false;
        },
      });
  }

  getProgile() {
    this.isLoading = true;
    this.apiUserService.GetProfile(this.token, this.uid).subscribe({
      next: (response: MyProfile) => {
        this.isLoading = false;
        if (response) {
          this.customer_name = response.fullName;
          this.phoneNo = response.phone;
        } else {
          console.log('No data');
        }
      },
      error: (error) => {
        console.error('API error:', error);
        this.isLoading = false;
      },
    });
  }

  // Discount Code
  getApiDiscountCode() {
    this.apiHandler.handleApi(
      this.apiDiscountService.getDiscountCode(this.providerId, this.discountCode, this.token),
      {
        logLabel: 'getDiscountCode',
        isConsoleLog: true,
        success: (response: CityParkingDiscountByCodeResponse) => {
          this.cityparkingDiscountByCode = response;
          this.disableDiscountCode = true;

          // ตรวจสอบราคาถูกต้องไหม
          if (this.cityparkingDiscountByCode.amount === 0) {
            this.showError(
              this.currentLang === 'TH'
                ? 'ไม่พบรหัสส่วนลด'
                : 'Not found discount code'
            );
            this.disableDiscountCode = false;
            this.cityparkingDiscountByCode = null;
            return;
          }
          this.calVehicleTotal();
        },
        error: (error) => {
          this.showError(
            this.currentLang === 'TH'
              ? 'ไม่พบรหัสส่วนลด'
              : 'Not found discount code'
          );
        },
        loading: (loading: boolean) => this.isLoading = loading,
      }
    )

  }

  // Tax
  ApigetAddressByTaxId() {
    this.apiMemberService.getAddressByTaxId(this.taxId.trim()).subscribe({
      next: (response: TaxpayerInfo) => {
        //this.isLoading = false;
        //  console.log(JSON.stringify(response).toString());
        if (!response || Object.keys(response).length === 0) {
          this.showError(
            this.currentLang === 'TH' ? 'ไม่พบข้อมูลผู้เสียภาษี' : 'Not found '
          );
          return;
        } else {
          this.taxName =
            response.company_branch_title_name + ' ' + response.company_name;
          this.address =
            response.company_address_no +
            ' หมู่ที่ ' +
            response.company_moo_number;
          if (response.company_branch_number === '0') {
            this.mainOffice = true;
          } else {
            this.mainOffice = false;
            this.branchName = response.company_branch_name;
          }
          const matchedProvince = this.provincess.find(
            (p) => p.name_th.trim() === response.company_province
          );
          if (matchedProvince) {
            this.selectedProvinceId = matchedProvince.id;
            this.province_name = response.company_province;
          } else {
            this.selectedProvinceId = null;
            this.province_name = '';
          }
          if (this.selectedProvinceId != null) {
            const provinceId = this.selectedProvinceId;
            this.filteredAmphures = this.amphures.filter(
              (a) => a.province_id === +provinceId
            );

            const selectedAmphureName = response.company_amphur;
            const matchedAmphure = this.filteredAmphures.find(
              (a) => a.name_th.trim() === selectedAmphureName
            );
            if (matchedAmphure) {
              this.selectedAmphureId = matchedAmphure.id;
              this.amphure_name = selectedAmphureName;
            } else {
              this.selectedAmphureId = null;
              this.amphure_name = '';
            }
          } else {
            this.filteredAmphures = [];
            this.selectedAmphureId = null;
            this.amphure_name = '';
          }
          if (this.selectedAmphureId != null) {
            const amphureId = this.selectedAmphureId;

            // กรองตำบลในอำเภอที่เลือก
            this.filteredTambons = this.tambons.filter(
              (a) => a.amphure_id === +amphureId
            );

            // ดึงชื่อจากที่อยู่
            const selectedTambonName = response.company_thambol;

            // หาใน list ว่าตรงกับตำบลไหน
            const matchedTambon = this.filteredTambons.find(
              (a) => a.name_th.trim() === selectedTambonName
            );

            if (matchedTambon) {
              this.selectedTambonId = matchedTambon.id;
              this.tambon_name = selectedTambonName;
              this.zipcode = response.company_postcode;
            } else {
              this.selectedTambonId = null;
              this.tambon_name = '';
              this.zipcode = '';
            }
          } else {
            this.filteredTambons = [];
            this.selectedTambonId = null;
            this.tambon_name = '';
          }
          this.syncAddressSearchTexts();
        }
      },
      error: (error) => {
        console.error('API error:', error);
        //this.isLoading = false;
      },
    });
  }

  decreaseVehicleCount(): void {
    this.vehicleCount = Math.max(this.vehicleCount - 1, 1);
  }
  goback() {
    this.router.navigate(['/home']);
  }
}

